import { isFirstPageVisitAfterLogin } from '../location';

function initializeHeapTracking(analyticsAccount, heapSettings) {
    // ref: https://docs.heap.io/docs/web
    window.heap = window.heap || [];
    const { heap } = window;
    // eslint-disable-next-line
    heap.load=function(e,t){window.heap.appid=e,window.heap.config=t=t||{};var r=t.forceSSL||"https:"===document.location.protocol,a=document.createElement("script");a.type="text/javascript",a.async=!0,a.src=(r?"https:":"http:")+"//cdn.heapanalytics.com/js/heap-"+e+".js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(a,n);for(var o=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},p=["addEventProperties","addUserProperties","clearEventProperties","identify","resetIdentity","removeEventProperty","setEventProperties","track","unsetEventProperty"],c=0;c<p.length;c++)heap[p[c]]=o(p[c])};
    heap.load(heapSettings.HeapAnalyticsEnvironmentId);

    if (heap && analyticsAccount && analyticsAccount.UserGuid) {
        if (!heap.identity) {
            heap.identify(analyticsAccount.UserGuid);
        }
        
        if (isFirstPageVisitAfterLogin()) {
            heap.addUserProperties({
                'Product - Account Id': analyticsAccount.AccountId,
                'Product - Unit Ceiling': analyticsAccount.AccountUnitCeiling,
                'Product - Units at Trial Signup': analyticsAccount.UnitsAtTrialSignup,
                'Product - Subscription Plan': analyticsAccount.SubscriptionPlan,
                'Product - Portfolio Type': analyticsAccount.PortfolioType,
                'Product - Account Type': analyticsAccount.UserGuid
            });
        }
    }    
}

export function prepareHeapAnalytics(analyticsAccount, heapAnalyticsSettings) {
    if (!heapAnalyticsSettings.IsHeapAnalyticsEnabled || analyticsAccount.AccountId <= 0) { return; }
    if (heapAnalyticsSettings.AccountUnitCeiling < heapAnalyticsSettings.HeapMinimumUnitCountToTrack) { return; }
    initializeHeapTracking(analyticsAccount, heapAnalyticsSettings);
}
